import React from "react";
import { useApp } from "@/context/AppContext";

// In-app confirmation popup (replaces the browser's native window.confirm).
export const ConfirmDialog = ({ open, title, description, confirmLabel, cancelLabel, danger = true, onConfirm, onCancel, testId = "confirm-dialog" }) => {
  const { t } = useApp();
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-black/50 p-4 animate-in fade-in"
      onClick={onCancel}
      data-testid={testId}
    >
      <div
        className="bg-white rounded-2xl p-5 w-full max-w-xs shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="font-bold text-sm mb-1" style={{ color: "var(--yalola-text)" }} data-testid={`${testId}-title`}>{title}</div>
        {description && (
          <p className="text-xs mb-4" style={{ color: "var(--yalola-text-muted)" }}>{description}</p>
        )}
        <div className={`flex gap-2 justify-end ${description ? "" : "mt-4"}`}>
          <button
            onClick={onCancel}
            className="px-3.5 py-1.5 rounded-full text-sm font-medium"
            style={{ background: "var(--yalola-surface-alt)", color: "var(--yalola-text)" }}
            data-testid={`${testId}-cancel`}
          >
            {cancelLabel || t("common.cancel", "Annuler")}
          </button>
          <button
            onClick={onConfirm}
            className="px-3.5 py-1.5 rounded-full text-sm font-medium text-white"
            style={{ background: danger ? "#e11d48" : "var(--yalola-primary)" }}
            data-testid={`${testId}-confirm`}
          >
            {confirmLabel || t("common.confirm", "Confirmer")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
